import { I18n } from '@calendly/i18n';
import { IconX } from '@calendly/ui/components/glyphs/IconX';
import { IconButton } from '@calendly/ui/components/icon-button';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context';
const headerCss = "h125rtzv";
const HeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const headerContentCss = "h13yveej";
const HeaderContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerContentCss, props.className)} />;
});
export const Header = () => {
  const {
    trackedMeeting: {
      name: trackedMeetingName
    },
    shareModal: {
      close: closeShareModal
    }
  } = useRecapShare();
  return <HeaderContainer>
      <HeaderContent>
        <TitleText level={2} size="large" as="h1">
          {I18n.t('publisher.meeting_recap.share_modal.title', {
          meeting_name: trackedMeetingName
        })}
        </TitleText>
        <BodyText color={colorTextSecondary}>
          {I18n.t('publisher.meeting_recap.share_modal.description')}
        </BodyText>
      </HeaderContent>
      <IconButton aria-label={I18n.t('publisher.action.close')} onClick={closeShareModal} size="small">
        <UiIcon icon={IconX} size="small" title="" />
      </IconButton>
    </HeaderContainer>;
};

require("./header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");